import React, { Component } from 'react';
import './FormElement.scss';
import PropTypes from 'prop-types';
import MaskedInput from 'react-maskedinput';
import FormError from '../FormError/FormError';

export default class FormElement extends Component {
  render() {
    return (
      <div
        className='form_element'
        style={this.props.style}
      >
        {this.props.void ? (
          this.props.children
        ) : this.props.mask ? (
          <MaskedInput
            className={this.props.className}
            mask={this.props.mask}
            placeholderChar=' '
            type={this.props.type}
            name={this.props.name}
            placeholder={this.props.placeholder}
            disabled={this.props.disabled}
            required={this.props.required}
            value={this.props.value}
            onChange={this.props.onChange}
            onKeyDown={this.props.onKeyDown}
          />
        ) : (
          <input
            className={this.props.className}
            type={this.props.type}
            name={this.props.name}
            placeholder={this.props.placeholder}
            disabled={this.props.disabled}
            required={this.props.required}
            value={this.props.value}
            onChange={this.props.onChange}
            onKeyDown={this.props.onKeyDown}
          />
        )}

        {this.props.hideLabel ? (
          <label
            htmlFor={this.props.id}
            className='hidden_label'
          >
            {' '}
            {this.props.label}{' '}
          </label>
        ) : (
          <label htmlFor={this.props.id}>{this.props.label}</label>
        )}

        {this.props.error !== '' ? <FormError inner={this.props.error} /> : null}
      </div>
    );
  }
}

FormElement.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  error: PropTypes.string,
};
